import { Alert, Checkbox } from '@clearcover/atlas';
import {
  CoveredPartyPayloadType,
  VehicleType,
} from '@clearcover/core-app-types';
import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import { Row } from 'Shared/components';
import { combineStrings, isPresent } from 'Shared/utils';
import styles from './styles.module.css';

type DriverVehicleAssignmentProps = {
  vehicles: Array<VehicleType>;
};

export const DriverVehicleAssignment: FC<DriverVehicleAssignmentProps> = ({
  vehicles,
}) => {
  const { setFieldValue, values, errors } = useFormikContext<
    CoveredPartyPayloadType
  >();

  const handleSelectVehicle = (v: string, isChecked: boolean) => {
    if (!isChecked) {
      setFieldValue(
        'assignedVehicles',
        values.assignedVehicles.filter((val: string) => val !== v)
      );
    } else {
      setFieldValue('assignedVehicles', [...values.assignedVehicles, v]);
    }
  };

  return (
    <div className={styles.section} data-testid="driver-vehicle-assignment">
      <h1>Vehicle Assignment</h1>
      <p>
        Please let us know which vehicles this driver will drive. Select all
        that apply.
      </p>
      <div className={styles.vehicleAssignmentSection}>
        {vehicles.map(({ identifier, year, make, model }) => (
          <Row key={identifier}>
            <Checkbox
              name={`driverVehicles_${identifier}`}
              value={values.assignedVehicles.includes(identifier)}
              label={combineStrings([year, make, model])}
              onChange={isChecked => handleSelectVehicle(identifier, isChecked)}
              error={!!errors.assignedVehicles}
            />
          </Row>
        ))}
      </div>
      {isPresent(errors.assignedVehicles) ? (
        <div className={styles.vehicleAssignmentSection}>
          <Alert
            type="error"
            message={
              Array.isArray(errors.assignedVehicles)
                ? errors.assignedVehicles[0]
                : errors.assignedVehicles
            }
          />
        </div>
      ) : null}
    </div>
  );
};
